import displayFlash from "partners/scripts/display_flash"

export default function readonlySelect() {
  window.addEventListener("click", copyContent)
}

const copyContent = event => {
  const el = event.target
  if (!el.dataset.copyFieldOnClick) return

  const message = event.target.dataset.copyFieldOnClick
  event.target.select()
  navigator.clipboard.writeText(event.target.value)
  document.getSelection().removeAllRanges()
  displayFlash(`Your ${message} has been copied to clipboard`)
}
